<template>
  <div class="user-form forgot-panel">
    <img class="logo" alt="ADRAYN" :src="$ComDomain.base + 'static/images/logo.png'">
    <h1><span>{{copyright.title}} &#8226; {{userform.hint.password.getback}}</span></h1>
    <Form @submit.native.prevent>
      <div class="form-group" v-if="!codeGot">
        <span :class="{'input-group-addon':1, 'text-primary':mobileFocus}" @click="mobileFocus=1"><Icon type="md-phone-portrait"></Icon></span>
        <Poptip v-model="mobileError" trigger="click" :content="warn.mobile" placement="bottom">
          <input v-focus="mobileFocus" @keyup.enter="codeFocus=1" @input="mobileError=false" @focus="mobileFocus=1" @blur="mobileFocus=0" v-model="user.mobile" :placeholder="message.content.input.replace('%', userform.field.regMobile)" style="padding-left:35px;" type="text" autocomplete="off" class="form-control" />
        </Poptip>
      </div>
      <div class="form-group big-text" v-else>
        {{userform.hint.code.sent.replace('%', userform.field.code)}}
        <span class="text-primary">{{user.mobile}}</span>
      </div>
      <code-getter process="forgot" ref="CodeGetter" v-focus="codeFocus" @focus="codeFocus=1" @blur="codeFocus=0" :user="user" :mobileError="mobileError" @done="doGetback" @code-got="codeGot=true" @code-lose="codeGot=false" @validate="validateMobile"></code-getter>
      <div class="form-group">
        <Button type="success" @click="doGetback" shape="circle">{{userform.forgot.getback}}</Button>
      </div>
      <div style="text-align:center;margin-top:-4px">
        <a role="button" @click="$store.commit('userEnter', {action: 'login'})">{{userform.forgot.login}}</a>
      </div>
    </Form>
  </div>
</template>
<script>
import { Icon, Button, Form } from 'iview'
import { copyright, message, userform, actions } from '../../locale'
import { validatePhone, vFocus } from '../../utils'
import CodeGetter from '../CodeGetter'
import Poptip from './Poptip'

export default {
  name: 'Forgot',
  data() {
    return {
      copyright,
      actions,
      userform,
      message,
      mobileFocus: 0,
      mobileError: false,
      codeFocus: 0,
      codeGot: false,
      warn: {
        mobile: ''
      },
      user: {
        mobile: this.$store.state.user.params.mobile,
        ic: ''
      }
    }
  },
  directives: {
    focus: vFocus
  },
  watch: {
    $route(to, from) {
      this.mobileError = false
    }
  },
  components: {
    Icon,
    Button,
    Form,
    Poptip,
    CodeGetter
  },
  methods: {
    validateMobile() {
      let result = validatePhone(this.user.mobile)
      this.user.mobile = result.correct
      this.warn.mobile = result.text
      this.mobileFocus = this.mobileError = result.error
      if (!result.error) return true
    },
    doGetback() {
      if (!this.validateMobile()) {
        return
      }
      this.$refs.CodeGetter.$emit('validate-then', () => {
        global.$ComAxios.put(this.$ComDomain.User.getPassword, this.user).then(response => {
          if (response.status == 200 && response.data.status == 200) {
            global.$Modal.info({
              title: message.title.info,
              render: (h) => {
                return h('p', userform.hint.password.plain.replace('%', response.data.plainCode))
              },
              onOk: () => {
                this.$store.commit('userEnter', { action: 'login' })
              }
            })
          } else {
            this.$refs.CodeGetter.$emit('code-error', { type: 'wrong' })
          }
        })
      })
    }
  },
  beforeCreate() {
    window.localStorage.setItem('Authorization', '')
  }
}

</script>
<style scoped lang="less">
.forgot-panel {
  .big-text {
    line-height: 36px;
  }
}

</style>



// WEBPACK FOOTER //
// src/commons/components/login/Forgot.vue